import React, {FC, ReactNode, useState} from 'react';
import Button from 'components/Button';
import {HubSpotForm} from 'components/ContentPagesComponents/HubSpotForm';
import DynamicAsset from 'components/DynamicAsset';

import * as styles from './styles.module.scss';

interface ImageProps {
	imageUrl: string;
}

export const BrandLogoImage: FC<ImageProps> = ({imageUrl}) => {
	return (
		<div className={styles.logo}>
			<DynamicAsset imageSrc={imageUrl} />
		</div>
	);
};

interface RowProps {
	children: ReactNode;
	title: string;
	buttonText: string;
	buttonForm: string;
	buttonLink: string;
}

const BrandLogoActionRow: FC<RowProps> = ({children, title, buttonForm, buttonText, buttonLink}) => {
	const [show, setShow] = useState(false);
	const toggle = () => setShow(!show);
	const Form = HubSpotForm(buttonForm);

	return (
		<div className={styles.wrapper}>
			<div className={styles.text}>
				<h3>{title}</h3>
			</div>
			<div className={styles.logos}>
				{children}
			</div>
			<div className={styles.row}>
				<a href={buttonLink}>
					<Button variant='primary' onClick={toggle}>
						{buttonText}
					</Button>
				</a>
				<Form show={show} onClose={toggle} />
			</div>
		</div>
	);
};

export default BrandLogoActionRow;
